__turbopack_context__.v({
  "control-gallery": "gxDrcq_control-gallery",
  "control-modal-column": "gxDrcq_control-modal-column",
  "control-modal-grid": "gxDrcq_control-modal-grid",
  "modal-copy": "gxDrcq_modal-copy",
  "modal-description": "gxDrcq_modal-description",
  "modal-logo": "gxDrcq_modal-logo",
  "request-info-modal": "gxDrcq_request-info-modal",
});
